<template>
    <div class="container">
        <order-list :orders="printedOrders"></order-list>
    </div>
</template>

<script>
    import {mapGetters} from "vuex"
    export default {
        name: 'printed-orders',
        data() {
            return {
            }
        },
        computed: Object.assign({}, mapGetters(['printedOrders'])),
    };
</script>



// WEBPACK FOOTER //
// PrintedOrders.vue?fb6670a2